<div class="main">
  @if (flightList$ | async) {
    <div class="flight-list">
      <router-outlet name="sidebar"></router-outlet>
    </div>
  }
  <div class="body" [ngClass]="{'no-margin-top': isReportOpened, 'flight-list-expanded': flightList$ | async}">
    @if (isLoading$ | async) {
      <emt-airplane-loader fullScreen="true"></emt-airplane-loader>
    }
    <emt-tab-bar [hidden]="isReportOpened"></emt-tab-bar>
    <router-outlet></router-outlet>
  </div>
</div>
